import React from 'react';
import type {RouteObject} from 'react-router-dom';
import type {
  ModuleEnum,
  PermissionOperationEnum,
  RoleEnum,
} from 'src/api/ProactApiClient';
import {PageLayout} from 'src/app/layout/PageLayout/PageLayout';
import {registerOfflineRoute} from 'src/offline/offlineRoutes';
import type {BackNavigationKind} from 'src/shared/services/backTrail';

export type RouteConfig = RouteObject & {
  backNavigation: BackNavigationKind;
  module?: ModuleEnum;
  operation?: PermissionOperationEnum;
  operationName?: string;
  roles?: RoleEnum[];
  isPrivate?: boolean;
  allowGlobalAdminBypass?: boolean;
  requireSuperAdmin?: boolean;
  /** Absent/false means the route is blocked while offline; only pages backed
   * by an offline session set this true. */
  supportsOffline?: boolean;
};

class RouteRegistry {
  private static instance: RouteRegistry;
  private routes: RouteConfig[] = [];

  private constructor() {}

  static getInstance(): RouteRegistry {
    if (!RouteRegistry.instance) {
      RouteRegistry.instance = new RouteRegistry();
    }
    return RouteRegistry.instance;
  }

  registerRoute(route: RouteConfig) {
    this.routes.push(route);
    if (route.supportsOffline && typeof route.path === 'string') {
      registerOfflineRoute(route.path);
    }
  }

  registerPageRoute(route: RouteConfig) {
    const wrapped: RouteConfig = {
      ...route,
      element: React.createElement(PageLayout, null, route.element),
    };
    this.registerRoute(wrapped);
  }

  getRoutes(): RouteConfig[] {
    return this.routes;
  }
}

export const routeRegistry = RouteRegistry.getInstance();
